import React from "react";
import Widget from "../../../../shared/components/features/widget/Widget";
import { useSelector } from "react-redux";
import pathRouts from "../../../../shared/enums/pathRoute";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import BotImg from "../../../../assests/assistantBotPage/AssistantBotImg.png";
import classes from "./PersonalAssistantBotWidget.module.css";

const PersonalAssistantBotWidget = () => {
    const { texts } = useSelector(state => state.translate);
    const botsTabRoute = `/${pathRouts.BOT}`;

    return (
        <Widget color="#DFDBF9" mainLink={botsTabRoute} title={texts.botTitle} icon={iconsList.bot} className={classes.PersonalAssistantBotWidget}>
            <div className={classes.AssistantBotContent}>
                <img src={BotImg} alt={texts.botTitle} className={classes.AssistantBotImg}/>
                <div className={classes.AssistantBotText}>
                    {texts.botTextWidget}
                </div>
            </div>
        </Widget>
    );
};

export default PersonalAssistantBotWidget;